import { RatingsSection } from 'app/components/rating-card';
import { SUPPORT_CHANNEL_URL } from 'app/network/chat/channel';
import { navigateToListing } from 'app/screens/billboard/navigator-helper';
import { navigateToChat } from 'app/screens/chat/navigator-helper';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { navigateToRatingEditor } from './shared';
import type { ProfileNavigation } from './shared';

export function ProfileRatingsSection({
  currentUserId,
  isMyself,
  navigation,
  ratedUserId,
  ratings,
  subjectName,
}: {
  currentUserId: string | undefined;
  isMyself: boolean;
  navigation: ProfileNavigation;
  ratedUserId: string;
  ratings: React.ComponentProps<typeof RatingsSection>['ratings'];
  subjectName: string;
}) {
  const { t } = useTranslation();
  return (
    <RatingsSection
      ratings={ratings}
      subjectName={subjectName || t('reviews.defaultSubject', { ns: 'neighbour-profile' })}
      onPressListing={(listingId) => navigateToListing(navigation, listingId)}
      currentUserId={currentUserId}
      ratedUserId={ratedUserId}
      variant={{ pendingRatings: isMyself ? 'hidden' : 'visible' }}
      onEditRating={(rating) => navigateToRatingEditor(navigation, rating)}
      onNavigateToSupport={() =>
        navigateToChat(navigation, SUPPORT_CHANNEL_URL, {
          i18nKey: 'reportRatingPrompt',
          ns: 'neighbour-profile',
        })
      }
    />
  );
}
